import Card from "@mui/material/Card";
import { ReactNode } from "react";

import Box from "themeComponents/Box";
import Typography from "themeComponents/Typography";
import PageLayout from "themeComponents/LayoutContainers/PageLayout";
import { appLogo, appName } from "configs/constants";
import { COMPCHECK_URL } from "configs/api";

interface IllustrationLayoutProps {
  children: ReactNode;
  maxWidth?: number | string;
}

function IllustrationLayout({
  children,
  maxWidth = 400,
}: IllustrationLayoutProps): React.JSX.Element {
  const domainName = window.location.hostname;
  const mainAppHost = process.env.REACT_APP_CLIENT_DOMAIN || "";
  const isMainApp = !mainAppHost || domainName === mainAppHost;
  const tenantLogo = localStorage.getItem("logo");
  const logoUrl =
    !isMainApp && tenantLogo ? `${COMPCHECK_URL}/api/${tenantLogo}` : appLogo;
  const brandName = isMainApp
    ? appName
    : domainName.split(".")[0].replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <PageLayout background="white">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        px={2}
        py={4}
      >
        <Box width="100%" maxWidth={maxWidth}>
          <Card
            sx={{
              borderRadius: 2,
              boxShadow: "0 8px 26px -4px rgba(20, 20, 20, 0.15), 0 8px 9px -5px rgba(20, 20, 20, 0.06)",
            }}
          >
            <Box textAlign="center" pt={4} px={3} pb={1}>
              <Box
                component="img"
                src={logoUrl}
                alt={brandName}
                height={64}
                sx={{ width: "auto", maxWidth: "100%", objectFit: "contain", mb: 1.5 }}
              />
              <Typography variant="h5" fontWeight="bold" color="dark">
                {brandName}
              </Typography>
            </Box>
            <Box px={3} pb={4} pt={2}>
              {children}
            </Box>
          </Card>
        </Box>
      </Box>
    </PageLayout>
  );
}

export default IllustrationLayout;
